import { useMutation } from '@apollo/client';
import { getSourceEventParams, useAmplitude } from '@crehana/analytics';

import DELETE_GENERATED_REPORT_MUTATION from './graphql/DeleteGeneratedReport.v4.b2b.graphql';
import type {
  DeleteGeneratedReport as GenerateReport,
  DeleteGeneratedReportVariables as GenerateReportVariables,
} from './graphql/types/DeleteGeneratedReport';

const useDeleteGeneratedReport = (slug: string) => {
  const { logEvent } = useAmplitude();
  const [generateAdministrationReport] = useMutation<
    GenerateReport,
    GenerateReportVariables
  >(DELETE_GENERATED_REPORT_MUTATION, {
    context: { clientName: 'v4.b2b' },
  });
  const deleteReport = async (organizationReportId: string) => {
    const responseReport = await generateAdministrationReport({
      variables: {
        organizationReportId,
      },
    });
    logEvent({
      event: 'Delete Generated Report',
      data: {
        ...getSourceEventParams(),
        Organization: slug,
        'Is Completed':
          responseReport.data?.updateOrganizationReportGeneration?.success,
      },
    });
  };

  return {
    deleteReport,
  };
};

export default useDeleteGeneratedReport;
